module.exports = __webpack_public_path__ + "81b3e7b4ed9d799757ba3a322a1b9198.png";